import React, { useState, useEffect } from 'react';
import { FaPlus, FaSearch, FaEdit, FaTrash, FaSave, FaTimes } from 'react-icons/fa';
import '../Nucleos/Nucleos.css';

import API_BASE_URL from '../../../../config/api';

const DocumentacaoTecnica = () => {
  const [documentacoesTecnicas, setDocumentacoesTecnicas] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [formData, setFormData] = useState({
    documentacao_tecnica: '',
    prazo: '',
    ativo: true
  });

  const carregarDocumentacoesTecnicas = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `${API_BASE_URL}/documentacao-tecnica`
      );

      if (!response.ok) {
        throw new Error('Erro ao buscar documentações técnicas');
      }

      const data = await response.json();
      setDocumentacoesTecnicas(data);
    } catch (error) {
      console.error('Erro ao carregar documentações técnicas:', error);
      alert(
        'Erro ao carregar documentações técnicas. Verifique a conexão com o servidor.'
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    carregarDocumentacoesTecnicas();
  }, []);

  const filteredDocumentacoesTecnicas = documentacoesTecnicas.filter((doc) =>
    doc.documentacao_tecnica
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.documentacao_tecnica.trim()) {
      alert('A descrição da documentação técnica é obrigatória.');
      return;
    }

    setSaving(true);

    try {
      const payload = {
        documentacao_tecnica: formData.documentacao_tecnica,
        prazo: formData.prazo || null,
        ativo: formData.ativo
      };

      if (editingId) {
        const response = await fetch(
          `${API_BASE_URL}/documentacao-tecnica/${editingId}`,
          {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
          }
        );

        if (!response.ok) {
          throw new Error('Erro ao atualizar documentação técnica');
        }

        const atualizado = await response.json();

        setDocumentacoesTecnicas((prev) =>
          prev.map((doc) => (doc.id === editingId ? atualizado : doc))
        );
      } else {
        const response = await fetch(
          `${API_BASE_URL}/documentacao-tecnica`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
          }
        );

        if (!response.ok) {
          throw new Error('Erro ao criar documentação técnica');
        }

        const criado = await response.json();

        setDocumentacoesTecnicas((prev) => [...prev, criado]);
      }

      resetForm();
    } catch (error) {
      console.error('Erro ao salvar documentação técnica:', error);
      alert(
        'Erro ao salvar documentação técnica. Verifique os dados e tente novamente.'
      );
    } finally {
      setSaving(false);
    }
  };

  const handleEdit = (doc) => {
    setFormData({
      documentacao_tecnica: doc.documentacao_tecnica,
      prazo: doc.prazo || '',
      ativo: doc.ativo
    });
    setEditingId(doc.id);
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Tem certeza que deseja excluir esta documentação técnica?')) {
      return;
    }

    try {
      const response = await fetch(
        `${API_BASE_URL}/documentacao-tecnica/${id}`,
        {
          method: 'DELETE'
        }
      );

      if (!response.ok && response.status !== 204) {
        throw new Error('Erro ao excluir documentação técnica');
      }

      setDocumentacoesTecnicas((prev) =>
        prev.filter((doc) => doc.id !== id)
      );
    } catch (error) {
      console.error('Erro ao excluir documentação técnica:', error);
      alert('Erro ao excluir documentação técnica. Tente novamente.');
    }
  };

  const handleToggleStatus = async (id) => {
    const doc = documentacoesTecnicas.find((d) => d.id === id);
    if (!doc) return;

    const novoAtivo = !doc.ativo;

    try {
      const response = await fetch(
        `${API_BASE_URL}/documentacao-tecnica/${id}`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            documentacao_tecnica: doc.documentacao_tecnica,
            prazo: doc.prazo,
            ativo: novoAtivo
          })
        }
      );

      if (!response.ok) {
        throw new Error('Erro ao atualizar status');
      }

      setDocumentacoesTecnicas((prev) =>
        prev.map((d) =>
          d.id === id ? { ...d, ativo: novoAtivo } : d
        )
      );
    } catch (error) {
      console.error('Erro ao atualizar status:', error);
      alert('Erro ao atualizar status. Tente novamente.');
    }
  };

  const resetForm = () => {
    setFormData({ documentacao_tecnica: '', prazo: '', ativo: true });
    setEditingId(null);
    setShowForm(false);
  };

  return (
    <div className="nucleos-container">
      <div className="tabela-header">
        <div className="header-content">
          <h1>Documentação Técnica</h1>
        </div>
      </div>

      {!showForm ? (
        <div className="table-container">
          <div className="table-controls">
            <div className="search-container">
              <FaSearch />
              <input
                type="text"
                placeholder="Pesquisar documentações técnicas..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            <div className="table-info">
              <span>
                {loading
                  ? 'Carregando...'
                  : `${filteredDocumentacoesTecnicas.length} registro(s) encontrado(s)`}
              </span>
            </div>
            <button 
              className="btn-primary"
              onClick={() => setShowForm(true)}
            >
              <FaPlus /> Nova Documentação
            </button>
          </div>

          <div className="table-wrapper">
            <table className="data-table nucleos-table">
              <thead>
                <tr>
                  <th className="col-id">ID</th>
                  <th className="col-prazo">Prazo (Dias)</th>
                  <th className="col-nome">Documentação Técnica</th>
                  <th className="col-status">Status</th>
                  <th className="col-acoes">Ações</th>
                </tr>
              </thead>
              <tbody>
                {filteredDocumentacoesTecnicas.map(doc => (
                  <tr key={doc.id}>
                    <td className="col-id">{doc.id}</td>
                    <td className="col-prazo">{doc.prazo || '-'}</td>
                    <td className="col-nome">{doc.documentacao_tecnica}</td>
                    <td className="col-status">
                      <label className="switch">
                        <input
                          type="checkbox"
                          checked={doc.ativo}
                          onChange={() => handleToggleStatus(doc.id)}
                        />
                        <span className="slider round"></span>
                      </label>
                    </td>
                    <td className="col-acoes">
                      <div className="action-buttons">
                        <button 
                          className="btn-edit"
                          onClick={() => handleEdit(doc)}
                          title="Editar"
                        >
                          <FaEdit />
                        </button>
                        <button 
                          className="btn-delete"
                          onClick={() => handleDelete(doc.id)}
                          title="Excluir"
                        >
                          <FaTrash />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            
            {filteredDocumentacoesTecnicas.length === 0 && !loading && (
              <div className="empty-state">
                <div className="empty-state-icon">
                  <FaSearch size={32} />
                </div>
                <h3>Nenhuma documentação técnica encontrada</h3>
                <p>Tente ajustar os filtros de pesquisa ou cadastre uma nova documentação.</p>
              </div>
            )}
          </div>
        </div>
      ) : (
        <div className="form-container inline-form">
          <div className="form-header">
            <h2>{editingId ? 'Editar Documentação Técnica' : 'Nova Documentação Técnica'}</h2>
          </div>
          
          <form onSubmit={handleSubmit} className="form-content">
            <div className="form-group">
              <label htmlFor="documentacao_tecnica">Documentação Técnica *</label>
              <input
                type="text"
                id="documentacao_tecnica"
                value={formData.documentacao_tecnica}
                onChange={(e) => setFormData({...formData, documentacao_tecnica: e.target.value})}
                required
                maxLength={200}
                placeholder="Digite a descrição da documentação técnica"
              />
            </div>

            <div className="form-group">
              <label htmlFor="prazo">Prazo (Dias)</label>
              <input
                type="number"
                id="prazo"
                value={formData.prazo}
                onChange={(e) => setFormData({...formData, prazo: e.target.value})}
                placeholder="Ex: 30"
                min="0"
              />
            </div>

            <div className="form-group">
              <div className="checkbox-container">
                <input
                  type="checkbox"
                  id="ativo"
                  checked={formData.ativo}
                  onChange={(e) => setFormData({...formData, ativo: e.target.checked})}
                />
                <label htmlFor="ativo">Ativo</label>
              </div>
            </div>

            <div className="form-actions">
              <button 
                type="button" 
                className="btn-secondary" 
                onClick={resetForm}
              >
                <FaTimes /> Cancelar
              </button>
              <button 
                type="submit" 
                className="btn-primary"
                disabled={saving}
              >
                <FaSave /> {saving ? 'Salvando...' : (editingId ? 'Atualizar' : 'Salvar')}
              </button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
};

export default DocumentacaoTecnica;
